import type { FaireProductEntity } from "../../entity_types/product";

export const p_35faeewhz8: FaireProductEntity = {
  token: "p_35faeewhz8",
  type: "product",
  name: "Farm Fresh Crackin Egg- Spring, Easter",
  brandToken: "b_83nqde8ah7",
  brandName: "Toysmith",
  imageUrl:
    "https://cdn.faire.com/fastly/9dfa729a1e7a74ea4681fbcbd2213b89989c23e8a0506cd8f363775699739094.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/102c4f2cbe8a55c5bf8192f589a4e1f2d855f1aacbba9f1877fa7d9bf403a1b9.jpeg",
    "https://cdn.faire.com/fastly/4002c37c67b925d4d653487cb02e2bcd4c984503f62e569f65c1394a0f652603.jpeg",
    "https://cdn.faire.com/fastly/dc431d99e0bd634684df2abb6fdc5ea7763e9028bbf1ab45cc5c79f06b7fb9c6.jpeg",
    "https://cdn.faire.com/fastly/f8e6e451a9c12b7793edf53a585f4fcf1904d1f58dbb94a83815921460c3927a.jpeg",
    "https://cdn.faire.com/fastly/6216d5c98ff64f25bb3b98c387403c84951d376831b8d9d7a674464d295c32c4.jpeg",
  ],
  priceDollars: 3.5,
  description:
    "The Crackin’ Egg Easter toy is a two-in-one delight that’s a must-have for every child. Include in a stocking or Easter basket, it’s great for year-round fun. Eggs are packaged individually. Bestseller during spring months and around the Easter holiday. Each 4.5-inch egg contains 1 fluffy, wind-up chick toy inside. Available in pastel yellow or light blue. Comes packaged in a spring-themed box illustrated with hatching chicks ready for gift-giving.\n\n• Age Grade: 5+\n• Product Dimensions/Weight: 3.25 L x 3.75 W x 5.25 H / 0.7 lb\n• Inner Pack Dimensions/Weight: 3.8 L x 3.3 W x 5.3 H / 0.4 lb\n• Made In: China\n• Batteries not required",
  tags: [],
  msrpDollars: 6.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:48:44.440Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
